import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

export const styles = {
  root: {
    selectors: {
      '& .url-options-toggle-button': {
        color: palette.themePrimary,
        fontWeight: 'bold',
        paddingLeft: 0,

        '& .ms-Icon': {
          marginLeft: 0,
        },
      },

      '& .url-options-parameters--read-only': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto 1fr 0px',
      },

      '& .url-options-parameters__param_label--read-only': {
        paddingRight: 6,
      },

      '& .url-options-parameters__param_value--read-only': {
        gridColumn: '2 / span 4',
        width: '100%',
        overflowWrap: 'break-word',
      },

      '& .custom-parameters-entry': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto 1fr 0px',
      },

      '& .custom-parameters-entry > div': {
        paddingRight: 6,
      },

      '& .custom-parameters-entry > .right-input': {
        paddingRight: 'unset',
      },

      '& .custom-parameters-entry > :not(:first-child)': {
        marginTop: 6,
      },

      '& .custom-parameters-entry > .left-label': {
        gridColumnStart: '1',
      },

      '& .custom-parameters-entry > .custom-parameter-value': {
        gridColumn: '2 / span 4',
        width: '100%',
      },

      '& .custom-parameters-entry > .errors': {
        gridColumn: '1 / span 5',
      },

      '& .custom-parameters-entry > .left-label, & .custom-parameters-entry > .right-label': {
        marginTop: 10,
      },

      '& .remove-url-parameter': {
        color: palette.neutralPrimary,
      },

      '& .remove-url-parameter:hover': {
        color: palette.neutralPrimary,
        backgroundColor: 'transparent',
      },

      '& .errors': {
        color: '#A80000',
        fontSize: 12,

        '& .error': {
          margin: '0 0 4px 0',
        },
      },

      '& .add-url-parameter': {
        color: palette.themePrimary,
      },
      '& .add-url-parameter:hover': {
        color: palette.themeDarker,
      },
    },
  },
};
